// extracted by mini-css-extract-plugin
module.exports = {"gender_label":"patient_gender-module__gender_label___+Zx-A","italicized":"patient_gender-module__italicized___Oj1bL"};